// services
import { Http } from "@shared/svelte/Modules/ApiService";

// stores
import { actionBarStore } from "@shared/svelte/Stores/ActionBarStore";

// types
import type { HTTPParams } from "@shared/types/HTTP";

// constants
const baseAdminUrl = "/api/admin/action_bar_data";
const baseRetailerUrl = "/api/retailer/action_bar_data";

const makeReq = async (requestData, successCB) => {
  const errCB = () => {
    actionBarStore.update(actionBarData => ({
      ...actionBarData,
      loaded: true,
      failed: true,
    }));
  };

  actionBarStore.update(actionBarData => ({
    ...actionBarData,
    loaded: false,
    failed: false,
  }));

  await Http(requestData, successCB, errCB);
};

export const get = async () => {
  const requestData: HTTPParams = {
    method: "GET",
    url: baseRetailerUrl,
  };

  const successCB = json => {
    actionBarStore.set({
      loaded: true,
      failed: false,
      data: json,
    });
  };

  makeReq(requestData, successCB);
};

export const update = async (data) => {
  const requestData: HTTPParams = {
    method: "PUT",
    url: baseAdminUrl,
    data: {
      description: data.description,
      image_upload_id: data.image_upload_id,
    },
  };

  const successCB = json => {
    actionBarStore.set({
      loaded: true,
      failed: false,
      data: json,
    });
  };

  makeReq(requestData, successCB);
};
